var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 429,
    viewBox: "0 0 401 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M381.53 89.2321C405.33 116.355 402.628 164.867 392.888 203.785C383.04 242.8 366.053 272.34 342.252 307.607C318.452 342.874 287.857 383.953 247.368 393.449C206.878 402.945 156.696 380.753 112.556 345.486C68.4151 310.219 30.2148 261.681 20.0483 203.471C9.88863 145.15 27.6207 77.0258 71.7678 49.9029C115.915 22.78 186.559 36.6516 247.043 46.4611C307.411 56.3685 357.722 62.1092 381.53 89.2321Z",
    fill: "black",
    fillOpacity: 0.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192.723 131.723C191.801 136.066 192.804 167.159 191.47 172.064C190.135 176.969 175.329 236.91 175.329 236.91L198.879 230.634C198.879 230.634 207.136 213.137 210.129 197.385C212.764 183.519 212.385 131.964 192.723 131.723Z",
    fill: "#D18C65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.863 145.45H154.583L145.832 113.448H161.119L169.863 145.45Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M367.746 234.435H201.73V394.514H367.746V234.435Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.474 282.508C241.713 282.508 249.203 275.286 249.203 266.376C249.203 257.467 241.713 250.245 232.474 250.245C223.234 250.245 215.744 257.467 215.744 266.376C215.744 275.286 223.234 282.508 232.474 282.508Z",
    fill: "#A4A4A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M263.264 259.461H348.084",
    stroke: "white",
    strokeWidth: 5.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M263.264 273.286H300.868",
    stroke: "white",
    strokeWidth: 5.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.264 307.561H348.084",
    stroke: "white",
    strokeWidth: 5.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M263.264 321.387H300.868",
    stroke: "white",
    strokeWidth: 5.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M263.264 355.654H348.084",
    stroke: "white",
    strokeWidth: 5.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M263.264 369.48H300.868",
    stroke: "white",
    strokeWidth: 5.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M232.474 330.602C241.713 330.602 249.203 323.379 249.203 314.47C249.203 305.561 241.713 298.339 232.474 298.339C223.234 298.339 215.744 305.561 215.744 314.47C215.744 323.379 223.234 330.602 232.474 330.602Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M232.474 378.702C241.713 378.702 249.203 371.48 249.203 362.571C249.203 353.662 241.713 346.439 232.474 346.439C223.234 346.439 215.744 353.662 215.744 362.571C215.744 371.48 223.234 378.702 232.474 378.702Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2327 385.038L58.8447 376.371L68.7199 393.809L50.5341 402.469L43.2327 385.038Z",
    fill: "#E49D75"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M157.772 376.37L161.254 395.643L182.365 392.182L175.403 370.31L157.772 376.37Z",
    fill: "#E49D75"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M210.021 222.868C203.804 223.195 101.78 244.557 100.453 249.567C89.5275 290.659 151.928 376.92 156.514 379.532C161.458 378.383 178.33 372.714 178.33 372.714L174.456 315.196L210.021 222.868Z",
    fill: "#E5B800"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1332 405.172L42.6706 380.054L8.75764 348.765L0 353.415L33.5743 415.458L55.1332 405.172Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M183.965 391.229L155.531 396.114L115.204 419.279L117.527 428.664L188.496 414.008L183.965 391.229Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M288.724 197.384C292.693 200.447 296.852 214.253 297.333 218.936C302.528 273.26 209.797 305.249 196.955 310.617C184.763 320.446 78.4255 396.035 71.9437 397.824C65.4618 399.614 54.8619 375.619 55.7898 372.413C56.7177 369.206 212.574 218.133 212.574 218.133L288.724 197.384Z",
    fill: "#FFCC00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M214.159 99.597C201.04 93.3469 188.909 127.628 190.074 131.553C191.239 135.478 203.282 136.601 206.329 136.601C209.377 136.601 214.159 99.597 214.159 99.597Z",
    fill: "#2B45D4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M239.315 79.9316C287.201 79.9316 291.719 190.01 291.177 197.521C286.341 212.829 228.336 231.221 210.482 221.156C182.15 157.101 195.202 79.9316 239.315 79.9316Z",
    fill: "#FFCC00",
    fillOpacity: 0.08
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M287.085 134.204C289.761 138.606 295.518 167.29 294.942 171.032C294.366 174.774 285.46 184.218 282.29 184.427C237.222 187.379 188.34 170.013 179.203 165.135C160.089 163.665 148.778 157.01 148.778 147.279C148.778 141.532 152.083 137.391 153.905 137.391C157.36 137.391 163.496 143.132 164.241 144.81C162.751 141.858 158.078 136.438 161.925 136.438C162.995 136.438 171.678 148.141 176.392 150.982C181.106 153.823 249.142 156.207 262.783 160.987C261.043 157.644 256.166 145.522 256.085 143.772C256.003 142.022 287.085 134.204 287.085 134.204Z",
    fill: "#E49D75"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M154.192 61.3198L128.708 66.203C125.891 66.7429 124.06 69.3832 124.62 72.1002L129.685 96.6723C130.245 99.3893 132.983 101.154 135.801 100.614L161.284 95.731C164.102 95.191 165.932 92.5507 165.372 89.8337L160.308 65.2616C159.748 62.5447 157.009 60.7798 154.192 61.3198Z",
    fill: "#2B45D4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.215 106.232L153.385 97.2324L143.713 99.0872L150.215 106.232Z",
    fill: "#2B45D4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M253.084 88.7027C273.816 81.375 290.207 127.562 289.537 133.413C288.866 139.265 255.671 149.512 251.932 147.396C248.194 145.28 232.534 95.9651 253.084 88.7027Z",
    fill: "#3453FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M240.67 59.9014C240.446 62.677 242.201 78.188 244.944 83.2494C243.731 85.5483 231.269 92.2294 225.302 90.7992C224.489 86.5018 222.328 74.9617 220.561 71.448C223.751 69.8414 240.67 59.9014 240.67 59.9014Z",
    fill: "#D18C65"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M225.355 73.3666C239.868 69.6535 247.721 52.4248 242.894 34.8853C238.068 17.3457 222.39 6.1371 207.877 9.85015C193.364 13.5632 185.512 30.7919 190.338 48.3314C195.165 65.871 210.842 77.0796 225.355 73.3666Z",
    fill: "#E49D75"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M229.385 41.1775C227.881 41.2559 222.144 38.4345 220.871 29.9704C216.732 29.3173 198.486 31.1917 188.922 38.4606C185.38 39.7668 182.508 40.8575 177.15 40.8575C174.61 40.8575 172.456 38.2974 172.456 36.5405C172.456 31.7011 174.61 27.0119 180.903 26.6984C175.606 26.5874 170.695 23.433 170.695 21.108C170.695 18.0188 177.977 8.54245 190.676 12.6961C187.696 10.6193 184.33 8.5947 184.33 6.62889C184.33 3.26546 189.349 0 198.127 0C211.707 0 226.506 5.4272 229.703 9.3131C231.193 8.56857 233.089 7.18402 236.72 7.18402C245.769 7.18402 248.803 35.4499 244.888 44.9262C243.919 45.5268 242.834 45.9333 241.698 46.1214",
    fill: "#E5B800"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M229.114 41.7976C229.563 40.5651 230.39 39.4934 231.485 38.7242C232.58 37.955 233.891 37.5248 235.246 37.4905C236.6 37.4562 237.933 37.8194 239.068 38.5321C240.204 39.2448 241.088 40.2732 241.603 41.4812C242.119 42.6892 242.242 44.0197 241.955 45.2965C241.669 46.5733 240.987 47.7361 240 48.6308C239.013 49.5256 237.767 50.11 236.428 50.3068C235.089 50.5036 233.719 50.3033 232.501 49.7327",
    fill: "#E49D75"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeplace);
export default __webpack_public_path__ + "static/media/Lifeplace.a6cf29209d3b14944c60474b83e944e7.svg";
export { ForwardRef as ReactComponent };